<div [id]="swiperContainerId"
   class="swiper-container bulb-image-carousel">
  <div class="swiper-wrapper">
    <div *ngFor="let slide of slides;let i = index"
       class="swiper-slide">
      <div class="image-wrapper" [ngStyle]="{height: getHeight()}">
        <bulb-image [isImageCarousel]="true"
                    [source]="source"
                    [maxHeight]="{height: getHeight()}"
                    [height]="slide.scaledImageAsset && slide.scaledImageAsset.url
                    ? slide.scaledImageAsset.height : slide.fullImageAsset.height"
                    [orientation]="orientation"
                    [imageId]="swiperContainerId +'-'+ i"
                    [isContentEditable] = "editable || (!editable && effect !== 'cube')"
                    [swiperId]="swiperContainerId"
                    [imageAsset]="slide.scaledImageAsset && slide.scaledImageAsset.url
                    ? slide.scaledImageAsset : slide.fullImageAsset">
        </bulb-image>
      </div>
      <div *ngIf="effect !== 'cube'" class="caption">
        <bulb-image-carousel-caption [caption]="slide.caption"></bulb-image-carousel-caption>
      </div>
    </div>
  </div>
  <div class="swiper-pagination"></div>
  <!-- Add Arrows -->
  <div class="swiper-button-next swiper-button-white"></div>
  <div class="swiper-button-prev swiper-button-white"></div>
</div>

